/** @format */
import Cookies from "js-cookie";

export async function getDoc(token, instanceId) {
  const api_url = Cookies.get("ApiUrl");
  const apiUrl = `${api_url}/document/list`;
  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify({
        InstanceId: instanceId,
      }),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    return data.message.list;
  } catch (error) {
    throw new Error(error);
  }
}
